import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from '@app/core/header/components/notifications/notifications.component';
import { MmaoService } from '@app/shared/components/mmao/services/mmao.service';
import { MmaoModule } from '@app/shared/components/mmao/mmao.module';

@NgModule({
  imports: [CommonModule, MmaoModule],
  providers: [MmaoService],
  declarations: [NotificationsComponent],
  exports: [NotificationsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsModule {}
